import angular from "angular";
import ngFileUpload from "ng-file-upload";

import { EnvironmentModule } from "../../../env/environment.module";
import { TemplateCacheModule } from "../../cache/template-cache.module";
import { FeatureFlagsModule } from "../../feature-flags/feature-flags.module";

import { ApiClientService } from "../api-client.service";
import { AuditLogService } from "./audit-log.service";
import { AuditorService } from "./auditor.service";
import { CommissionPolicyService } from "./commission-policy.service";
import { DashboardService } from './dashboard.service';
import { DivisionService } from './division.service';
import { EmployeeService } from './employee.service';
import { EmploymentProcessingService } from './employment-processing.service';
import { EventHostService } from './event-host.service';
import { HomeService } from './home.service';
import { HubService } from './hub.service';
import { IcdCommissionsService } from './icd-commissions.service';
import { IcdCorporationReportService } from './icd-corporation-report.service';
import { IcdCorporationService } from './icd-corporation.service';
import { IcdOfficeService } from './icd-office.service';
import { LeadBatchServiceFactory } from './lead-batch.service';
import { LeadOfficeTeamService } from './lead-office-team.service';
import { LeadsPolicyService } from './leads-policy.service';
import { LeadsService } from './leads.service';
import { LegalNoticeService } from './legal-notice.service';
import { MessageService } from './message.service';
import { MultiPlayCommissionPolicyService } from './multi-play-commission-policy.service';
import { NationalConsultantService } from './national-consultant.service';
import { NavigationService } from './navigation.service';
import { OnboardingApplicationService } from './onboarding-application.service';
import { OnboardingDivisionService } from './onboarding-division.service';
import { OnboardingPolicyService } from './onboarding-policy.service';
import { OnboardingStatusService } from './onboarding-status.service';
import { PayStubService } from './pay-stub.service';
import { PayoutPolicyService } from './payout-policy.service';
import { PayrollDashboardService } from './payroll-dashboard.service';
import { PayrollEntryService } from './payroll-entry.service';
import { PayrollFinancialsService } from './payroll-financials.service';
import { PayrollInvoicePolicyService } from './payroll-invoice-policy.service';
import { PayrollInvoiceService } from './payroll-invoice.service';
import { PayrollService } from './payroll.service';
import { PostedPayoutService } from './posted-payout.service';
import { ProductCommissionPolicyService } from './product-commission-policy.service';
import { ProductLineService } from './product-line.service';
import { ProductOrderAdjustmentService } from './product-order-adjustment.service';
import { ProductService } from './product.service';
import { ProgramService } from './program.service';
import { PromotingOwnerService } from './promoting-owner.service';
import { RegionalConsultantService } from './regional-consultant.service';
import { ReportJobService } from './report-job.service';
import { RetailerService } from './retailer.service';
import { RogersDashboardService } from './rogers-dashboard.service';
import { RogersLeadsStatisticsService } from './rogers-leads-statistics.service';
import { RogersPayoutReportService } from './rogers-payout-report.service';
import { RoleService } from './role.service';
import { RotationsService } from './rotations.service';
import { RsPayoutTransfersService } from './rs-payout-transfers.service';
import { RSScheduleService } from './rs-schedule.service';
import { ScheduleEventTimeSlotService } from './schedule-event-time-slot.service';
import { ScheduleEventService } from './schedule-event.service';
import { SiteFeatureService } from './site-feature.service';
import { SiteModuleService } from './site-module.service';
import { StateProvinceService } from './state-province.service';
import { TeamService } from './team.service';
import { TimeCardService } from './time-card.service';
import { TimeEntryComplianceService } from './time-entry-compliance.service';
import { TimeEntryService } from './time-entry.service';
import { WagePolicyService } from './wage-policy.service';
import { WorkOrderManualClaimService } from './work-order-manual-claim.service';
import { WorkOrderService } from './work-order.service';
import { BankAccountService } from "./bank-account.service";
import { AdpConfigService } from "./adp-config.service";
import { OnboardingDocumentService } from "./onboarding-document.service";

export const DataServiceModule = angular
    .module("apex.core.data", [
        ngFileUpload,
        // Use the environment defined in the EnvironmentModule
        EnvironmentModule,
        FeatureFlagsModule,
        TemplateCacheModule
    ])
    .service("adpConfigService", AdpConfigService)
    .service("apiClientService", ApiClientService)
    .factory("auditLogService", AuditLogService)
    .factory("auditorService", AuditorService)
    .service("bankAccountService", BankAccountService)
    .factory("commissionPolicyService", CommissionPolicyService)
    .factory("dashboardService", DashboardService)
    .service("divisionService", DivisionService)
    .factory("employeeService", EmployeeService)
    .service("employmentProcessingService", EmploymentProcessingService)
    .service("eventHostService", EventHostService)
    .service("hubService", HubService)
    .factory("icdCommissionsService", IcdCommissionsService)
    .service("icdCorporationService", IcdCorporationService)
    .service("icdCorporationReportService", IcdCorporationReportService)
    .service("icdOfficeService", IcdOfficeService)
    .service("homeService", HomeService)
    .service("leadsService", LeadsService)
    .service("leadsPolicyService", LeadsPolicyService)
    .factory("leadBatchService", LeadBatchServiceFactory)
    .factory("leadOfficeTeamService", LeadOfficeTeamService)
    .service("legalNoticeService", LegalNoticeService)
    .service("messageService", MessageService)
    .factory("multiPlayCommissionPolicyService", MultiPlayCommissionPolicyService)
    .service("nationalConsultantService", NationalConsultantService)
    .service("navigationService", NavigationService)
    .service("onboardingApplicationService", OnboardingApplicationService)
    .service("onboardingDocumentService", OnboardingDocumentService)
    .factory("onboardingDivisionService", OnboardingDivisionService)
    .factory("onboardingPolicyService", OnboardingPolicyService)
    .service("onboardingStatusService", OnboardingStatusService)
    .service("payStubService", PayStubService)
    .service("payrollService", PayrollService)
    .factory("payrollDashboardService", PayrollDashboardService)
    .service("payrollEntryService", PayrollEntryService)
    .factory("payrollFinancialsService", PayrollFinancialsService)
    .service("payrollInvoiceService", PayrollInvoiceService)
    .factory("payrollInvoicePolicyService", PayrollInvoicePolicyService)
    .factory("payoutPolicyService", PayoutPolicyService)
    .factory("postedPayoutService", PostedPayoutService)
    .factory("productsService", ProductService)
    .factory("productCommissionPolicyService", ProductCommissionPolicyService)
    .factory("productLinesService", ProductLineService)
    .service("productOrderAdjustmentService", ProductOrderAdjustmentService)
    .factory("programService", ProgramService)
    .service("promotingOwnerService", PromotingOwnerService)
    .service("regionalConsultantService", RegionalConsultantService)
    .service("reportJobService", ReportJobService)
    .factory("retailerService", RetailerService)
    .factory("rogersDashboardService", RogersDashboardService)
    .factory("rogersLeadsStatisticsService", RogersLeadsStatisticsService)
    .service("rogersPayoutReportService", RogersPayoutReportService)
    .service("roleService", RoleService)
    .service("rotationsService", RotationsService)
    .factory("rsScheduleService", RSScheduleService)
    .service("scheduleEventService", ScheduleEventService)
    .factory("rsPayoutTransfersService", RsPayoutTransfersService)
    .service("scheduleEventTimeSlotService", ScheduleEventTimeSlotService)
    .service("siteModuleService", SiteModuleService)
    .service("siteFeatureService", SiteFeatureService)
    .service("stateProvinceService", StateProvinceService)
    .service("teamService", TeamService)
    .factory("timeCardService", TimeCardService)
    .service("timeEntryComplianceService", TimeEntryComplianceService)
    .service("timeEntryService", TimeEntryService)
    .service("wagePolicyService", WagePolicyService)
    .factory("workOrderService", WorkOrderService)
    .factory("workOrderManualClaimService", WorkOrderManualClaimService)
    .name;
